import { Component, Input } from '@angular/core';
import { DatagridNoData } from '@zipari/shared-ds-util-datagrid';

@Component({
  selector: 'datagrid-no-data',
  templateUrl: './datagrid-no-data.component.html',
  styleUrl: './datagrid-no-data.component.scss',
})
export class DatagridNoDataComponent {
  @Input() noData: DatagridNoData;
}
